module.exports = __webpack_public_path__ + "static/img/img12.7e3d960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img12.png
// module id = hIos
// module chunks = 1